import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    region: [],
  },

  getters: {
    getRegion: (state) => state.region,

    getRegionExploracion: (state) => {
      const regionExploracion = [];

      state.region.forEach((region) => {
        regionExploracion.push({
          fk_idCatRegion: region.id,
          diagnostico: '',
        });
      });

      return regionExploracion;
    },
  },

  mutations: {
    SET_REGION(state, region) {
      state.region = region;
    },
  },

  actions: {
    async fetchRegion({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catRegion')
        .then((response) => {
          commit('SET_REGION', response.data.data);
        });
    },
  },
};
